// extracted by mini-css-extract-plugin
export default {"tabList":"StarGiftCollectionList-module__tabList"};